{
  "instances": {
    "auditevents": {
      "audit_log_not_supported_spring_boot_1": "Spring Boot 1.x 的應用程式不支援稽核日誌。",
      "event": "事件",
      "loading_audit_events": "正在載入稽核事件...",
      "no_audit_events_found": "找不到稽核事件。",
      "principal": "主體",
      "remote_address": "遠端位址",
      "session_id": "Session ID",
      "timestamp": "時間戳記",
      "type": "類型",
      "label": "稽核日誌"
    }
  }
}
